module.exports = __webpack_public_path__ + "static/bottom-b9922a54652426cc8a275e38cea3ca25.png";